const scenarioMetadata = {
  categories: [
    { id: 1, name: "Management of planned events" },
    { id: 2, name: "Management of real-time traffic conditions" },
    { id: 3, name: "Predictive traffic management" }
  ],
  kpis: [
    {
      id: 1,
      kpi_id: "kpi_future_events",
      category_id: 1,
      name: "Future Events",
      monitoring: {
        type: "events",
        selection: "single",
      },
    },
    {
      id: 2,
      kpi_id: "kpi_metro_status",
      category_id: 2,
      name: "Metro Status",
      type_id: 100,
      options: [
        { id: 1, options_id: "normal", label: "Normal operation" },
        { id: 2, options_id: "not_normal", label: "Not normal operation" },
      ],
    },
    {
      id: 3,
      kpi_id: "kpi_congestion_areas",
      category_id: 2,
           type_id: 10,
      name: "Congestion Areas",
      options: [
        { id: 1, options_id: "low", label: "Low" },
        { id: 2, options_id: "medium", label: "Medium" },
        { id: 3, options_id: "high", label: "High" },
         { id: 4, options_id: "no", label: "No Congestion" },
      ],
      monitoring: {
        type: "areas",
        selection: "single",
      },
    },
    {
      id: 4,
      kpi_id: "kpi_congestion_routes",
      category_id: 2,
           type_id: 10,
      name: "Congestion Routes",
      options: [
         { id: 4, options_id: "no", label: "No Congestion" },
        { id: 1, options_id: "low", label: "Low" },
        { id: 2, options_id: "medium", label: "Medium" },
        { id: 3, options_id: "high", label: "High" },
       
      ],
      monitoring: {
        type: "routes",
        selection: "single",
      },
    },
        {
      id: 5,
      kpi_id: "predicted_routes_travle_time",
      category_id: 3,
           type_id: 10,
      name: "Predicted Route Travel Time",
      options: [
        { id: 1, options_id: "increasing", label: "Increasing" },
        { id: 2, options_id: "decreasing", label: "Decreasing " },
      ],
      monitoring: {
        type: "routes",
        selection: "single",
      },
    },
  ],
  actions: [
    {
      id: 1,
      action_id: "info",
      name: "Information",
      targets: [
        { id: 1, name: "Waze" },
        { id: 2, name: "SYNCHROMODE EXCΗANGE REPOSITORY" },
      ],
    },
    {
      id: 2,
      action_id: "alert",
      name: "Alert",
      targets: [],
    },
  ],
};

export default scenarioMetadata;
